import React, { Component } from "react"
import { Grid } from "@material-ui/core"
import Text from "../../atoms/Text"
import ContentCard from "../../molecules/ContentCard"

export default class MainContents extends Component {
  render() {
    return (
      <Grid>
        <Grid style={{ display: "flex", justifyContent: "center" }}>
          <ContentCard name="こんな仲間を求めます">
            <Text>・笑顔で挨拶ができる人</Text>
            <Text>・要領が悪い人</Text>
            <Text>・人と違っていることを恐れない人</Text>
            <Text>・明るく面白い人</Text>
            <Text>・約束を大切だと思う人</Text>
          </ContentCard>
        </Grid>
        <Grid style={{ display: "flex", justifyContent: "center" }}>
          <ContentCard name="選考">
            <Text bold inlineBox>
              提出課題
            </Text>
            <Text inlineBox>と</Text>
            <Text bold inlineBox>
              面接
            </Text>
            <Text inlineBox>によります。</Text>
            <Text hidden />
            <br />
            <Text hidden />
            <br />
            <Text bold fontSize="20px">
              提出課題
            </Text>
            <br />
            <Text hidden />
            <Text inlineBox>以下を提出をしてください。締め切りは</Text>
            <Text bold inlineBox>
              【2019年4月3日(水) 23:59】とします。
            </Text>
            <br />
            <Text hidden />
            <br />
            <Text>・姓名</Text>
            <Text>・住所、連絡先電話番号、メールアドレス</Text>
            <Text>・出身高校</Text>
            <Text>・所属する部活、またはサークル</Text>
            <Text>
              ・自己紹介（上の「こんな仲間を求めます」を参考に；英語で200
              words程度」）
            </Text>
            <Text>・志望理由（同じく英語で200 words 程度）</Text>
            <br />
            <Text hidden />
            <br />
            <Text hidden />
            <br />
            <Text bold fontSize="20px">
              申込方法
            </Text>
            <br />
            <Text hidden />
            <Text>
              上記の内容について、形式はWordで(PDFでも可)、件名を「新規入ゼミ希望（あなたのお名前）」として、下記二つのアドレス宛にメールで提出してください。
            </Text>
            <br />
            <Text hidden />
            <Text>katahira@mbforum.jp</Text>
            <Text>katahirasemi2019shinkan@gmail.com</Text>
            <Text hidden />
            <br />
            <Text inlineBox>面接は</Text>
            <Text bold inlineBox>
              【4月6日(土)】
            </Text>
            <Text inlineBox>
              に丸の内オフィスで行うので空けておくこと。時間は個別に連絡します。
            </Text>
          </ContentCard>
        </Grid>
      </Grid>
    )
  }
}
